module.exports = __webpack_public_path__ + "assets/img/742995125efe1e2a87bfc4ae873e3379.svg";